export default "__VITE_ASSET__BRR25pSE__"